export const GET_EXAM_TYPE_LABELS = 'GET_EXAM_TYPE_LABELS'
export const ADD_EXAM_TYPE_LABEL = 'ADD_EXAM_TYPE_LABEL'
export const VIEW_SELECTED_EXAM_TYPE_LABEL = 'VIEW_SELECTED_EXAM_TYPE_LABEL'
export const UPDATE_EXAM_TYPE_LABEL = 'UPDATE_EXAM_TYPE_LABEL'
export const DELETE_SINGLE_EXAM_TYPE_LABEL = 'DELETE_SINGLE_EXAM_TYPE_LABEL'
export const DELETE_MANY_EXAM_TYPE_LABELS = 'DELETE_MANY_EXAM_TYPE_LABELS'
